import { type HeadingType } from '@Types/Shared/Heading';

import Html from '../Html';

// className needed for paddding title of the bloc TextImg variant fullWidth !!
// if no heading only fullWidth TxtImg, no space btw blocks should be visible

export default function Heading(props: HeadingType) {
	const {
		title,
		titleFormat = 'h1',
		description,
		headingAlign = 'center',
		className = '',
		headingFontClassName = {
			title: '',
			text: {
				p: '',
				h1: '',
				h2: '',
				h3: '',
				h4: '',
				h5: '',
				h6: '',
				a: {
					style: 'a',
					btnDecorationElement: 'short',
					btnHasIcon: false,
					aClassname: '',
				},
				btnPrimary: {
					style: 'primary',
					btnDecorationElement: 'short',
					btnHasIcon: false,
					primaryClassname: '',
					animation: 'none',
				},
				btnSecondary: {
					style: 'secondary',
					btnDecorationElement: 'short',
					btnHasIcon: false,
					secondaryClassname: '',
					animation: 'none',
				},
				btnTertiary: {
					style: 'tertiary',
					btnDecorationElement: 'short',
					btnHasIcon: false,
					tertiaryClassname: '',
				},
			},
		},
		context = '',
	} = props;

	const headingAligns = {
		left: 'text-left tablet:mb-6 mb-5 block mr-auto tablet:max-w-3xl max-w-sm',
		center: 'text-center tablet:mb-6 mb-5 mx-auto block tablet:max-w-3xl max-w-sm',
		right: 'text-right tablet:mb-6 mb-5 block ml-auto tablet:max-w-3xl max-w-sm',
	};

	return (
		<>
			{title || description ? (
				<div className={`${headingAligns[headingAlign]} ${className}`}>
					{title && (
						<>
							{titleFormat === 'h1' ? (
								<h1 className={`mb-5 text-4xl tablet:mb-6 ${headingFontClassName?.title}`}>{title}</h1>
							) : (
								<h2 className={`mb-5 text-3xl tablet:mb-6 ${headingFontClassName?.title}`}>{title}</h2>
							)}
						</>
					)}
					<div>
						<Html context={context} className={headingFontClassName?.text} html={description} />
					</div>
				</div>
			) : (
				''
			)}
		</>
	);
}
